module.exports = __webpack_public_path__ + "static/media/UnpaidLeave.e15e904e.svg";